export const showJSADialog = (options) => async dispatch => {
    dispatch({type: 'SHOW_JSA_DIALOG', options});
};

export const hideJSADialog = () => async dispatch => {
    dispatch({type: 'HIDE_JSA_DIALOG'});
};